import h from 'hyperscript';

interface SeparatorOptions {
  dark?: boolean;
}

/**
 * Creates a horizontal separator.
 *
 * @param [options]
 * @param [options.dark] - Whether to toggle the dark variant
 * @return The separator element
 */
export function createHorizontalSeparator (options?: SeparatorOptions) {
  return applyOptions(h('hr'), options);
}

/**
 * Creates a vertical separator.
 *
 * @param [options]
 * @param [options.dark] - Whether to toggle the dark variant
 * @return The separator element
 */
export function createVerticalSeparator (options?: SeparatorOptions) {
  return applyOptions(h('div', { attrs: { role: 'separator', 'aria-orientation': 'vertical' } }), options);
}

function applyOptions (el: HTMLElement, { dark = false }: SeparatorOptions = {}) {
  el.classList.toggle('d-separator-dark', dark);
  return el;
}

export {
  createHorizontalSeparator as hr,
  createVerticalSeparator as vr
};
